const initializationParams = (apiKey, environment, locale, region)=>{
    return {
        selector: '.virtual-mirror__target',
        locale,
        vmInit: {
            key: apiKey,
            environment,
            glassesEnv: 'PROD',
            source: 'VMMV_CXD_GLOBAL',
            channel: 'ecommerce',
            brand: 'cxd'
        },
        isPictureModeEnabled: true,
        isTryOnEnabled: true,
        isVideoModeEnabled: true,
        isTakePictureEnabled: true,
        isTakeScreenshotEnabled: false,
        store: {
            id: '',
            storeId: '',
            type: 'rb',
            region
        },
        style: '',
        fromStore: true
    };
};

export { initializationParams };
//# sourceMappingURL=initOptions.js.map
